import CriteriaActions from './CriteriaActions';
import {
  updateDashboardViewItemQuery, setModifiedViewItems, updateDashboardQueryGraphConfig, saveTabFilters,
} from './DashboardQueryActions';

export {
  // eslint-disable-next-line import/prefer-default-export
  CriteriaActions,
  updateDashboardViewItemQuery,
  updateDashboardQueryGraphConfig,
  setModifiedViewItems,
  saveTabFilters,
};
